import React from 'react'
import { createUseStyles } from 'react-jss'
import { colors } from '../../../theme/palette'

type RuleNames =
    | 'label'
    | 'input'
    | 'container'
    | 'innerContainer'
    | 'groupLabel'

type Props = {
    options: {
        label: string
        value: string
    }[]
    groupLabel: string
    activeValue: string
} & React.ComponentPropsWithoutRef<'input'>

const useStyles = createUseStyles<RuleNames, Jss.Theme>({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    innerContainer: {
        display: 'flex',
        padding: '.5rem',
        border: `1px solid ${colors.green}`,
        borderRadius: '0.5rem',
        opacity: 0.5,
    },
    input: {
        opacity: 0,
        width: 0,
        '&:checked + label:before': {
            border: `7px solid ${colors.green}`,
        },
        '&:checked': {
            '&::after': {
                content: '""',
            },
        },
    },
    label: {
        position: 'relative',
        paddingLeft: '1.7rem',
        '&:before': {
            content: '""',
            position: 'absolute',
            display: 'inline-block',
            left: 0,
            top: '50%',
            marginTop: '-0.6rem',
            height: '1.2rem',
            width: '1.2rem',
            border: `1px solid ${colors.green}`,
            borderRadius: '3rem',
            backgroundColor: colors.white,
            fontSize: '1.125rem',
            cursor: 'pointer',
        },
        fontSize: '1rem',
        color: colors.black,
        marginLeft: '1rem',
        cursor: 'pointer',
    },
    groupLabel: {
        fontWeight: 700,
        textAlign: 'center',
    },
})

const RadioButtons: React.FC<Props> = ({
    options,
    groupLabel,
    activeValue,
    ...props
}) => {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <p className={classes.groupLabel}>{groupLabel}</p>
            {!!options &&
                options.map((option) => (
                    <div
                        className={classes.innerContainer}
                        key={option.label}
                        style={{
                            opacity: activeValue === option.value ? 1 : 0.5,
                        }}
                    >
                        <input
                            type="radio"
                            id={option.label}
                            className={classes.input}
                            {...props}
                            value={option.value}
                            name={groupLabel}
                            key={option.label}
                            checked={activeValue === option.value}
                        />
                        <label className={classes.label} htmlFor={option.label}>
                            {option.label}
                        </label>
                    </div>
                ))}
        </div>
    )
}

export default RadioButtons
